import { useRef, useState } from "react"
import axiosInstance from "../Services/Api"

const IpModal = ({ isOpen, onClose }) => {
    const [ipValue, setIpValue] = useState(''); // State to manage the IP input value
    const [isLoading, setIsLoading] = useState(false); // State to manage loading

    const handleSetIp = async () => {
        setIsLoading(true); // Set loading to true when starting the request
        try {
            if (ipValue === '') {
                alert('Preencha o campo de IP');
                return;
            }
            const data = {
                ip: ipValue
            };
            const response = await axiosInstance.post('/api/setIp', data);
            alert('IP adicionado com sucesso');
        } catch (e) {
            if (e.status === 401) {
                localStorage.removeItem('token');
                window.location.reload();
            }
            if(e.status === 400){
                alert(e.response.data.detail)
                return
            }
            alert('Erro ao adicionar IP');
        } finally {
            setIsLoading(false); // Reset loading state after the request is complete
        }
    }

    const handleInputChange = (e) => {
        const value = e.target.value;
        // Allow only numbers and dots, and limit to 15 characters
        if (/^[0-9.]*$/.test(value) && value.length <= 15) {
            setIpValue(value); // Update state with valid input
        }
    }

    if (!isOpen) {
        return null;
    }

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[999999]">
            <div className="bg-[#1D1D1D] w-full p-2 pb-4 mb-4 rounded-lg shadow-lg w-11/12 max-w-md">
                <div className="relative border-b w-full flex justify-center items-center">
                    <h1 className="text-white">Adicione o IP</h1>
                    <p className="cursor-pointer text-white absolute right-[10px] text-[20px]" onClick={()=>onClose(false)}>x</p>
                </div>
                <div className="px-4 mt-2">
                    <label className="text-[#AEB9E1] text-[14px]">IP:</label>
                    <input 
                        className="w-full mt-2 bg-[#313131] p-2 focus:outline-none text-white rounded-[10px]" 
                        value={ipValue} // Set the input value from state
                        type="text" 
                        onChange={handleInputChange} 
                    />
                </div>
                <div className="w-full mt-4 text-white px-8">
                    <button 
                        disabled={isLoading} 
                        className={`w-full rounded-[10px] p-3 ${isLoading ? 'bg-gray-500' : 'bg-[#478DF8]'}`}
                        onClick={handleSetIp}
                    >
                        {isLoading ? 'Enviando...' : 'Adicionar IP'}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default IpModal;